import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "../constants/UrlConstants";
import HealthInformationImg from "../assets/img/card-images/access-health-information_556x323.jpg";
import HealthInformationImgMobile from "../assets/img/card-images/access-health-information_290x170.jpg";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";
import linkStyles from "../assets/css/modules/shared/link.css";

const ClaimDetails = {
  uploadInvoiceButtonType: {
    HOL: "primaryOrangeButton",
    Any: "secondaryOrangeButton"
  },
  backToMyClaims: "My claims",
  AlreadyPaidInfo: "If you've already paid, you don't need to do anything but please be aware that this display will not be updated.",
  header: <h1>Claim details</h1>,
  details: (
    <p>
      Details of your claim can be found here. Please keep a record of the claim
      number below and take to any appointments for this condition. To ask us a
      question about this claim, please{" "}
      <Link
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        to={Paths.ContactUs}
      >
        contact us
      </Link>
      .
    </p>
  ),
  invoiceHeader: <h2>Payments we've assessed</h2>,
  invoiceDetails: (
    <p>
      Payments for your claim that we've assessed so far are shown below.
      We've shown where a payment is needed and once you've made a payment you can ignore this instruction.
      Please click on payment details to see what happened, what we’ve paid and what you need to do.
    </p>
  ),
  authoriseTreatmentButtonLabel: "Authorise treatment",
  authoriseTreatmentDesc: "Authorise a treatment for this claim",
  uploadInvoiceButtonLabel: "Upload Invoice",
  uploadInvoiceDesc: "Upload an invoice for this claim",
  claimNumberLabel: "Claim number",
  claimNumberTooltip:
    "The claim number is the unique number for this claim. This is also known as the pre-authorisation number. Please take this number to any appointments that you have for this condition, and quote this if you ever need to contact us about this claim.",
  conditionLabel: "Condition",
  conditionStatusLabel: "Condition status",
  noInvoicesMessage: (
    <p>
      We haven't yet assessed any invoices for this claim, and will be in touch
      shortly.
    </p>
  ),
  conditionStatusTooltip: {
    MOL: {
      Approved: "The condition is approved and covered.",
      OnHold: "Your claim is currently on hold",
      Pending: `Something is either pending with you or ${RebrandHelper.getAxaBrandName()} – e.g. information from the GP, specialist, ${RebrandHelper.getAxaBrandName()}, or from you.`,
      NotCovered: (
        <React.Fragment>
          <span>
            We're unable to cover your condition due to the rules of your plan.
            Common reasons are:
          </span>
          <ul>
            <li>
              The condition you’re claiming for isn’t included as standard
            </li>
            <li>There might be a benefit limit on your plan </li>
            <li>
              You might have chosen a plan without cover for certain types of
              treatment
            </li>
            <li>You might have a pre-existing condition</li>
          </ul>
          <span>For more detail, please refer to your handbook.</span>
        </React.Fragment>
      ),
      Closed: "Generally, a claim is closed after 6 months of activity."
    },
    HOL: {
      Approved: "The condition is approved and covered.",
      OnHold: "Your claim is currently on hold",
      Pending:
        "Something is either pending with you or Health-on-Line – e.g. information from the GP, specialist, Health-on-Line, or from you.",
      NotCovered: (
        <React.Fragment>
          <span>
            We're unable to cover your condition due to the rules of your
            policy. Common reasons are:
          </span>
          <ul>
            <li>
              The condition you’re claiming for isn’t included as standard
            </li>
            <li>There might be a benefit limit on your policy </li>
            <li>
              You might have chosen a policy without cover for certain types of
              treatment
            </li>
            <li>You might have a pre-existing condition</li>
          </ul>
          <span>For more detail, please refer to your handbook.</span>
        </React.Fragment>
      ),

      Closed: "Generally, a claim is closed after 6 months of activity."
    }
  },
  Promo: {
    LinkTo: Paths.HealthInformation,
    LinkText: "Discover",
    ImgSrc: HealthInformationImg,
    ImgSrcMobile: HealthInformationImgMobile,
    Heading: "Access health information",
    Description:
      "Find information online and local services with Health Unlocked, helping you to manage and understand your health.",
    AriaLabel: "Discover health information"
  },
  HelpSection: {
    HeadingLinkTo: Paths.Help,
    HeadingLinkText: "Help",
    MoreHelpLinkTo: Paths.Help,
    MoreHelpLinkText: "View more help"
  },
  HelpSet: [
    {
      Question: "How do I authorise a new treatment?",
      Answer: (
        <p>
          If you have a new treatment to authorise, please click on the
          'Authorise treatment' button on Claim details page. Alternatively, you
          can click on the 'Make a claim' button from the homepage.
        </p>
      )
    },
    {
      Question: "How do I upload a new invoice for treatment?",
      Answer: (
        <p>
          If you have a new invoice to upload, please click on the 'Upload
          invoice' button on Claim details page. Alternatively, you can click on
          the 'Make a claim' button from the homepage.
        </p>
      )
    },
    {
      Question: "How do I view payment details for my claim?",
      Answer: (
        <p>
          To view the payment details for your claims, please go to the claim
          details page for the relevant claim. Then click on the 'Payment
          details' button. You'll be able to view details for any payments that
          we've assessed.
        </p>
      )
    }
  ],
  HelpSetEP: (AuthUrl, ClaimBackUrl,IsInternalView)=>[
    {
      Question: "How do I authorise a new treatment?",
      Answer: IsInternalView?(
        <p>
          If you have a new treatment to authorise, please {"  "}
          <Link to="/" 
          className={linkStyles.disabled} 
          onClick={ (event) => event.preventDefault() }>
          contact us to check if your membership covers your treatment.{" "}
          </Link>
        </p>
      ):(
        <p>
              If you have a new treatment to authorise, please {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={AuthUrl}
              target="_blank"
              rel="noopener"
            >
              contact us to check if your membership covers your treatment.{" "}
            </a>
            </p>
      )
    },
    {
      Question: "How do I upload a new invoice for treatment?",
      Answer: IsInternalView?(
        <p>
          If you have a new invoice to send us, you can {"  "}
          <Link to="/" 
          className={linkStyles.disabled} 
          onClick={ (event) => event.preventDefault() }>
          upload your documents here.{" "}
          </Link>
        </p>
        ):(
        <p>
              If you have a new invoice to send us, you can {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={ClaimBackUrl}
              target="_blank"
              rel="noopener"
            >
              upload your documents here.{" "}
            </a>
            </p>
      )
    },
    {
      Question: "How do I view payment details for my claim?",
      Answer: (
        <p>
          To view the payment details for your claims, please go to the claim
          details page for the relevant claim. Then click on the 'Payment
          details' button. You'll be able to view details for any payments that
          we've assessed.
        </p>
      )
    }
  ],
  dateNotifiedLabel: "Date you notified us",
  paymentDetailsButtonLabel: "Payment details",
  invoiceCell: {
    noProviderName: "Provider unknown",
    paymentNeededStatus: "payment shortfalled",
    costCoveredStatus: "cost covered",
    providerNameLabel: "Provider name: ",
    providerRefLabel: "Provider ref: ",
    ourRefLabel: "Our ref: "
  }
};

export default ClaimDetails;
